// Menu e busca em tela cheia (uma sobreposição por vez, como na v36): o fundo fica inerte e a sobreposição ganha
// uma entrada no histórico, para o Voltar do Android fechá-la em vez de sair da página.
const _abertas = [];
// Quantos history.back() da própria tela ainda vão chegar no popstate (duas fechadas seguidas são dois).
let _ignorarPopstate = 0;

function _fundo() {
    return [document.querySelector('.site-h'), document.getElementById('v2Lat'), document.getElementById('conteudo'), document.getElementById('footer-empregare'), document.querySelector('.bnav')]
        .filter(Boolean);
}

export function travarFundo(ligar) {
    _fundo().forEach(el => { el.inert = ligar; });
    document.documentElement.classList.toggle('v2-travado', ligar);
}

// O endereço é opcional: o sheet da vaga entra com ?vaga= (o Voltar tira o parâmetro junto).
export function empilhar(marca, aoVoltar, endereco) {
    history.pushState({ ...(history.state || {}), [marca]: true }, '', endereco);
    _abertas.push({ marca, aoVoltar });
}

// Fechou pela tela (X, fundo, Esc): tira a entrada que a sobreposição pôs no histórico.
export function desempilhar(marca) {
    const i = _abertas.findIndex(a => a.marca === marca);
    if (i < 0) {
        return;
    }
    _abertas.splice(i, 1);
    if (history.state?.[marca]) {
        _ignorarPopstate++;
        history.back();
    }
}

// Saindo de dentro de uma sobreposição, a entrada dela no histórico é trocada pela página nova:
// senão o Voltar da próxima página cai nela e precisa de dois toques.
export function irPara(endereco) {
    if (_abertas.length && history.state?.[_abertas[_abertas.length - 1].marca]) {
        window.location.replace(endereco);
    } else {
        window.location.href = endereco;
    }
}

export function iniciarSobreposicao() {
    // Marca que sobrou de uma visita anterior (voltar sem bfcache): a sobreposição já está fechada.
    if (history.state && Object.keys(history.state).some(k => k.startsWith('v2'))) {
        const estado = { ...history.state };
        Object.keys(estado).filter(k => k.startsWith('v2')).forEach(k => delete estado[k]);
        history.replaceState(estado, '');
    }

    // Volta pelo bfcache depois de sair de dentro de uma sobreposição. Pelo irPara a entrada dela foi trocada: fecha. Por um link
    // comum (o "Abrir página" do sheet da vaga) a volta cai na entrada dela: continua aberta, e o Voltar seguinte a fecha.
    window.addEventListener('pageshow', e => {
        if (e.persisted) {
            _ignorarPopstate = 0;
            while (_abertas.length && !history.state?.[_abertas[_abertas.length - 1].marca]) {
                _abertas.pop().aoVoltar();
            }
        }
    });

    window.addEventListener('popstate', () => {
        if (_ignorarPopstate > 0) {
            _ignorarPopstate--;
            return;
        }
        _abertas.pop()?.aoVoltar();
    });
}
